/**
 * Couleur
 */
export class BoutiqueProduitCouleur {
    /**
     * Constructeur de l'objet BoutiqueProduitCouleur
     * @param contact contient les données de l'objet
     */
    constructor(produitCouleur) {
        if (produitCouleur) {
            const { idProduitCouleur, libelle, codeCouleur, actif } = produitCouleur;
            this.idProduitCouleur = idProduitCouleur;
            this.libelle = libelle;
            this.codeCouleur = codeCouleur;
            this.actif = actif;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm91dGlxdWVQcm9kdWl0Q291bGV1ci5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkJvdXRpcXVlUHJvZHVpdENvdWxldXIuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sc0JBQXNCO0lBcUJsQzs7O09BR0c7SUFDSCxZQUFtQixjQUFnRDtRQUNsRSxJQUFJLGNBQWMsRUFBRTtZQUNuQixNQUFNLEVBQUUsZ0JBQWdCLEVBQUUsT0FBTyxFQUFFLFdBQVcsRUFBRSxLQUFLLEVBQUUsR0FBRyxjQUFjLENBQUM7WUFFekUsSUFBSSxDQUFDLGdCQUFnQixHQUFHLGdCQUFnQixDQUFDO1lBQ3pDLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDO1lBQ3ZCLElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFDO1lBQy9CLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO1NBQ25CO0lBQ0YsQ0FBQztDQUNEIn0=